import React from 'react';
import Icon from '../../../components/AppIcon';

const RequirementCard = ({ 
  requirement, 
  onSelect, 
  isSelected, 
  onDragStart, 
  onDragEnd,
  isDragging 
}) => {
  const getComplexityColor = (complexity) => {
    switch (complexity) {
      case 'Low': return 'bg-success/10 text-success border-success/20';
      case 'Medium': return 'bg-warning/10 text-warning border-warning/20';
      case 'High': return 'bg-destructive/10 text-destructive border-destructive/20';
      default: return 'bg-muted/10 text-muted-foreground border-border';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Proposed': return 'bg-muted text-muted-foreground';
      case 'Analyzing': return 'bg-warning text-warning-foreground';
      case 'Fit': return 'bg-success text-success-foreground';
      case 'Gap': return 'bg-destructive text-destructive-foreground';
      case 'Approved': return 'bg-primary text-primary-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const handleDragStart = (e) => {
    e?.dataTransfer?.setData('text/plain', requirement?.id);
    onDragStart(requirement);
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragEnd={onDragEnd}
      onClick={() => onSelect(requirement)}
      className={`bg-card border border-border rounded-lg p-4 cursor-pointer hover:shadow-elevation-2 nav-transition ${
        isSelected ? 'ring-2 ring-primary border-primary' : ''
      } ${isDragging ? 'opacity-50 rotate-2' : ''}`}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground truncate">
            {requirement?.title}
          </h4>
          <p className="text-xs text-muted-foreground mt-1">
            {requirement?.type} • {requirement?.lob}
          </p>
        </div>
        <div className="flex items-center space-x-2 ml-2">
          <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getComplexityColor(requirement?.complexity)}`}>
            {requirement?.complexity}
          </span>
        </div>
      </div>
      {/* Description */}
      <p className="text-xs text-muted-foreground mb-3 line-clamp-2">
        {requirement?.description}
      </p>
      {/* SAP Standard Assessment */}
      <div className="mb-3">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs font-medium text-foreground">SAP Standard</span>
          <span className="text-xs text-muted-foreground">{requirement?.sapFitPercentage}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-1.5">
          <div 
            className={`h-1.5 rounded-full ${
              requirement?.sapFitPercentage >= 80 ? 'bg-success' :
              requirement?.sapFitPercentage >= 60 ? 'bg-warning' : 'bg-destructive'
            }`}
            style={{ width: `${requirement?.sapFitPercentage}%` }}
          />
        </div>
      </div>
      {/* Footer */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {requirement?.assignee && (
            <div className="flex items-center space-x-1">
              <div className="w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                <span className="text-xs text-primary-foreground font-medium">
                  {requirement?.assignee?.charAt(0)?.toUpperCase()}
                </span>
              </div>
              <span className="text-xs text-muted-foreground">
                {requirement?.assignee?.split(' ')?.[0]}
              </span>
            </div>
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          {requirement?.effortDays && (
            <span className="text-xs text-muted-foreground">
              {requirement?.effortDays}d
            </span>
          )}
          {requirement?.hasRicefw && (
            <Icon name="Code" size={12} className="text-accent" />
          )}
          <Icon name="GripVertical" size={12} className="text-muted-foreground" />
        </div>
      </div>
    </div>
  );
};

export default RequirementCard;